import { __rest } from "tslib";
import { createElement } from 'rax';
import dayjs from 'dayjs';
import { FieldElement } from '../field';
import TimePicker from '../time-picker';
export default class TimePickerField extends FieldElement {
    renderPreview(value) {
        const { dateFormat = 'HH:mm' } = this.props;
        return dayjs(value).format(dateFormat);
    }
    renderControl() {
        const _a = this.props, { dateFormat } = _a, other = __rest(_a, ["dateFormat"]);
        return <TimePicker format={dateFormat} {...other}/>;
    }
}
TimePickerField.displayName = 'TimePickerField';
